<template>
    <div class="lab" v-if="pool && pool.measurements && pool.measurements.length">
        <h1 class="pr-1">
            Lab results
            <w-button v-if="backUrl" :to="backUrl" class="px-4 float-right">Back</w-button>
        </h1>
        <div class="info">As of {{formattedMeasureTime}}</div>

        <div v-for="meas of pool.measurements" :key="meas.title" class="measure">
            <div class="d-flex justify-content-between">
                <div class="title">{{ meas.title }}</div>
                <div class="message d-flex">
                    <span v-for="alert of meas.alerts" :key="alert.text" class="mr-3 d-flex align-items-end">{{alert.text}}</span>
                    <div v-if="meas.status !== 'GREEN'" @click="selectedMeas = meas" class="fa fa-exclamation-triangle float-right" :style="{color: meas.color}"></div>
                </div>
            </div>
            <div class="d-flex cursor-pointer">
                <progress-bar :meas="meas" :status-colors="statusColors"></progress-bar>
                <div class="chevron-right" @click="selectedMeas = meas">
                    <img alt="info" src="../assets/img/Chevron-right@2x.png">
                </div>
            </div>
        </div>
        <modal :show="!!selectedMeas">
            <div class="text-center" v-if="selectedMeas">
                <div class="mb-5 modal-text">
                    {{selectedMeas.cfg.desc}}
                </div>
                <w-button :inverse="true" @click="selectedMeas = null" class="px-5">Close</w-button>
            </div>
        </modal>
    </div>
    <div v-else class="lab mt-2">
        <h4>
            No lab results available for this pool.
        </h4>
        <w-button v-if="backUrl" :to="backUrl" class="px-4">Back</w-button>
    </div>
</template>
<script>
import moment from 'moment-timezone'
import ProgressBar from './ProgressBar'
import Modal from './Modal'

export default {
    name: 'Lab',
    props: {
        pool: {
            required: true
        },
        statusColors: {
            required: true,
            type: Object
        },
        backUrl: {
            type: String
        }
    },
    data () {
        return {
            selectedMeas: null
        }
    },
    components: {
        Modal,
        ProgressBar
    },
    computed: {
        formattedMeasureTime () {
            return moment(this.pool.latestMeasureTime).format('MM.DD.YY / h:mma')
        }
    }
}
</script>

<style scoped>
    .lab {
        color: #1a3f65;
    }

    h1 {
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 0;
    }

    .info {
        font-size: 12px;
        color: #7B8C9F;
    }

    .measure {
        border-bottom: 0.5px solid #7B8C9F;
        padding: 15px 14px 15px 0;
    }

    .message .fa-exclamation-triangle {
        font-size: 20px;
        cursor: pointer;
    }

    .title {
        font-size: 17px;
        font-weight: 600;
    }

    .message {
        font-size: 10px;
        font-weight: 600;
        height: 20px;
    }

    .chevron-right {
        width: 5%;
        cursor: pointer;
    }

    .chevron-right img {
        width: 10px;
        display: block;
        position: relative;
        top: 30px;
        left: 15px;
    }

    .fa-exclamation-triangle:before,
    .fa-exclamation-triangle:after {
        position: static;
    }

    .modal-text {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }

    @media (max-width: 768px) {
        h1 {
            font-size: 22px;
        }

        .info {
            font-size: 9px;
        }

        .chevron-right img {
            width: 7px;
            top: 31px;
        }

        .message .fa-exclamation-triangle {
            font-size: 16px;
        }
    }
</style>
